import { HardwareModels } from "types/productTypes";

export const PACKAGE_NAME = "com.Oculera.perimetryVR20";
export const APP_FILES_DIR = `/sdcard/Android/data/${PACKAGE_NAME}/files`;

/**
 * The headset app's Oculera folder. The HTC app has no shared-storage access, so it keeps the
 * folder in app-specific storage, which adb can still write to.
 */
export function oculeraDeviceDir(model: HardwareModels): string {
  return model === HardwareModels.HtcFocusVision ? `${APP_FILES_DIR}/Oculera` : "/sdcard/Oculera";
}

export function isVAAudioAsset(assetName: string): boolean {
  return assetName.toLowerCase().endsWith(".wav");
}

/**
 * Returns the absolute path where the asset should be stored on the device. Audio names
 * carry their .wav extension, videos are extensionless and get .mp4 appended.
 */
export function getVAAssetDevicePath(
  model: HardwareModels,
  languageCode: string,
  assetName: string,
): string {
  const isAudio = isVAAudioAsset(assetName);
  const folder = isAudio ? "VAAudios" : "VAVideos";
  const fileName = isAudio ? assetName : `${assetName}.mp4`;
  return `${oculeraDeviceDir(model)}/${folder}/${languageCode}/${fileName}`;
}
